import { useEffect } from 'react';
import isExists from 'date-fns/isExists';

const useUpdateBirthDate = formik => {
  useEffect(() => {
    const { birthDate, date_of_birth } = formik.values;

    let [birthDay, birthMonth, birthYear] = date_of_birth.split(' ');

    birthDay = parseInt(birthDay, 10);
    birthMonth = parseInt(birthMonth, 10) - 1;
    birthYear = parseInt(birthYear, 10);

    if (
      birthDay !== birthDate?.getDate?.() ||
      birthMonth !== birthDate?.getMonth?.() ||
      birthYear !== birthDate?.getFullYear?.()
    ) {
      const isValidBirthDate = isExists(birthYear, birthMonth, birthDay);

      if (isValidBirthDate) {
        const newBirthDate = new Date(birthYear, birthMonth, birthDay);

        formik.setFieldValue('birthDate', newBirthDate);
      } else if (birthDate !== false) {
        formik.setFieldValue('birthDate', false);
      }
    }
  }, [formik.values.date_of_birth]);
};

export default useUpdateBirthDate;
